import {
  IRequirementResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { getRequirementDefinitionTableCellProps } from "../../../../RequirementDefinitions/utils";
import { CustomRequirement, RequirementStatusViewProps } from "../../../types";
import { getTaxVerificationRequirementName } from "../../TaxVerification/configs/helpers/getTaxVerificationRequirementName";

export function getTaxVerificationCustomRequirement(
  requirements: IRequirementResponse[]
): CustomRequirement {
  const baseRequirement = requirements[0];

  const allRequirementsComplete = requirements.every(
    requirement => requirement.status === RequirementStatus.Complete
  );

  const allRequirementsTaxVerified = requirements.every(
    requirement =>
      requirement.dataSourceMetadata?.verificationStatus === "Verified"
  );

  const status =
    allRequirementsComplete || allRequirementsTaxVerified
      ? RequirementStatus.Complete
      : RequirementStatus.Incomplete;

  return {
    payerId: baseRequirement.payerId,
    status,
    nameCell: {
      text: getTaxVerificationRequirementName(baseRequirement)
    },
    typeCell: getRequirementDefinitionTableCellProps({
      type: baseRequirement.requirementType
    }),
    clientsCell: {
      text: `${requirements.length} clients`
    },
    engagementsCell: {},
    statusCell: getStatusCell(status),
    menuActions: []
  };
}

const getStatusCell = (
  status: RequirementStatus
): RequirementStatusViewProps => {
  switch (status) {
    case RequirementStatus.Complete:
      return {
        pill: {
          text: "Complete",
          theme: "success",
          icon: true
        }
      };

    default:
      return {
        pill: {
          theme: "warning",
          text: "Action required",
          icon: true
        }
      };
  }
};
